import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_CHANNEL_DETAILS } from './url-constants';

type AlarmChannelDetailsEndpointSpecification = ApiEndpointSpecification;
export const AlarmChannelDetailsEndpointSpecification: AlarmChannelDetailsEndpointSpecification = {
    url: ALARM_CHANNEL_DETAILS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'AlarmChannelDetailsRequestParams',
    requestBodySchemaName: 'AlarmChannelDetailsRequestBody',
    okResponseSchemaName: 'AlarmChannelDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2   

};

export const invokeAlarmChannelDetails = Helpers.makeApiRequestFn<
    Types.AlarmChannelDetailsRequestParams,
    Types.AlarmChannelDetailsRequestBody,
    Types.AlarmChannelDetailsOkResponse
>(AlarmChannelDetailsEndpointSpecification);
